import { useNavigate, useLocation } from "react-router-dom";
import { useCallback } from "react";

const useAppNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to, options) => {
      if (typeof to === "number") {
        navigate(to);
        return;
      }

      const current = new URLSearchParams(location.search);
      const theme = current.get("theme") || localStorage.getItem("theme") || "light";
      const language = current.get("language") || "en";

      const url = new URL(to, window.location.origin);
      url.searchParams.set("theme", theme);
      url.searchParams.set("language", language);

      navigate(url.pathname + url.search, options);
    },
    [navigate, location.search]
  );
};

export default useAppNavigate;
